import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';
import { IconEditComponent } from '@pedix-workspace/angular-ui-icons';
import { TooltipComponent } from '@pedix-workspace/angular-ui-tooltip';
import { TranslocoService } from '@ngneat/transloco';

export type OrderDetailsDisableReason = 'order-billed' | 'order-shipped' | 'empty-custom-fields';

@Component({
    selector: 'pxw-order-details-section',
    templateUrl: './order-details-section.component.html',
    styleUrls: ['./order-details-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, IconEditComponent, TooltipComponent]
})
export class OrderDetailsSectionComponent {
  private t = inject(TranslocoService);

  readonly title = input.required<string>();
  readonly editEnabled = input(false);
  readonly disabledReasons = input<Partial<Record<OrderDetailsDisableReason, boolean>>>({});

  readonly edit = output();

  readonly disabledEditButton = computed(() => this.disabledEditTooltip() !== null);

  readonly disabledEditTooltip = computed(() => {
    if (this.disabledReasons()['order-billed']) {
      return this.t.translate('orderDetails.orderWasBilledError');
    }
    if (this.disabledReasons()['order-shipped']) {
      return this.t.translate('orderDetails.orderWasShippedError');
    }
    if (this.disabledReasons()['empty-custom-fields']) {
      return this.t.translate('orderDetails.noCustomFieldsError');
    }
    return null;
  });
}
